import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

function fetchVersion() {
    const minutesSinceEpoch = Math.floor(Date.now() / 1000 / 60);
    return axios.get(`/version.txt?${minutesSinceEpoch}`, {
        baseURL: window.location.origin,
    })
}

export function useCacheBusting() {
    const [currentVersion, setCurrentVersion] = useState<string>(
        process.env.REACT_APP_COMMIT_REF ?? "",
    );

    const { data: version } = useQuery({
        queryKey: ["cache-busting"],
        queryFn: fetchVersion,
        refetchInterval: 15 * 60 * 1000,
        enabled: process.env.NODE_ENV !== "development",
    })

    useEffect(() => {
        if (version && version.data) {
            if (currentVersion === "") {
                setCurrentVersion(version.data);
            } else if (currentVersion !== version.data) {
                window.location.reload();
            }
        }
    }, [version]);
}